import React, { useState, useEffect } from "react";
import "./Future.css";
import { useNavigate } from "react-router-dom";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";
import FutureAnimation from "./FutureAnimation"; 

const NAV_ITEMS = [ { label: "About Us", path: "/about", type: "page" }, { label: "Our Team", path: "/team", type: "page" }, { label: "Services", path: "/#services", type: "scroll" }, { label: "Contact", path: "/contact", type: "page" } ];

function Future() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => { document.querySelector(item.path.replace("/", "")).scrollIntoView({ behavior: "smooth" }); }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App future-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>
      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}><img src={logo} alt="Logo" className="header-logo" /></a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}><div className="bar"></div><div className="bar"></div><div className="bar"></div></div>
      </header>
      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>{NAV_ITEMS.map((item, i) => <li className="dropdown-item" key={i}><a onClick={() => handleNav(item)}>{item.label}</a></li>)}</ul>
      </nav>

      <section className="future-hero">
        <div className="container">
          <h1>Future Outlook</h1> 
          <div className="future-divider"></div>
        </div>
      </section>

      <section className="section white-bg">
        <div className="container split-layout">
          <div className="text-content">
            <h2>Global Reach & Innovation</h2>
            <p>
              The firm has strategically positioned itself to address future challenges arising from a liberalized and globalized working environment. We are actively establishing partnerships with international legal firms and financial advisors to enhance our global reach and expertise.
            </p>
          </div>
          <div className="animation-content">
             <FutureAnimation />
          </div>
        </div>
      </section>

      <footer className="App-footer">
        <div className="qr-box"><img src={QRCode} alt="QR" /></div>
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}
export default Future;